<template>
  <span class="survey-checkbox">
    <input
      type="checkbox"
      :checked="checked"
      class="survey-checkbox__input"
      @change="onChange"
    />
    <span class="survey-checkbox__custom"></span>
  </span>
</template>

<script>
export default {
  name: "SurveyCheckbox",
  props: {
    checked: {
      type: Boolean,
      required: true,
    },
    onChange: {
      type: Function,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.survey-checkbox {
  position: relative;

  &__input {
    position: absolute;
    opacity: 0;
    width: 0;
    height: 0;
  }

  &__custom {
    display: block;
    width: 20px;
    height: 20px;
    border-radius: 7px;
    border: 3px solid #ee7e30;
    background-color: #ffffff;
    flex-shrink: 0;
    position: relative;
    box-sizing: border-box;
    transition: border-color 0.2s, background-color 0.2s;

    &::after {
      content: "";
      position: absolute;
      left: 50%;
      top: 45%;
      width: 5px;
      height: 9px;
      border-right: 3px solid #000000;
      border-bottom: 3px solid #000000;
      transform: translate(-50%, -50%) rotate(45deg);
      opacity: 0;
    }
  }

  &__input:checked + &__custom {
    &::after {
      opacity: 1;
    }
  }
}
</style>
